import React, { SVGProps } from 'react';

function ReceivedIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4.60303 14.75C4.39053 14.75 4.2124 14.6782 4.06865 14.5344C3.9249 14.3907 3.85303 14.2125 3.85303 14V8.00004C3.85303 7.78754 3.9249 7.60941 4.06865 7.46566C4.2124 7.32191 4.39053 7.25004 4.60303 7.25004C4.81553 7.25004 4.99365 7.32191 5.1374 7.46566C5.28115 7.60941 5.35303 7.78754 5.35303 8.00004V12.2L13.528 4.02504C13.6655 3.88754 13.8405 3.81879 14.053 3.81879C14.2655 3.81879 14.4405 3.88754 14.578 4.02504C14.7155 4.16254 14.7843 4.33754 14.7843 4.55004C14.7843 4.76254 14.7155 4.93754 14.578 5.07504L6.40303 13.25H10.603C10.8155 13.25 10.9937 13.3219 11.1374 13.4657C11.2812 13.6094 11.353 13.7875 11.353 14C11.353 14.2125 11.2812 14.3907 11.1374 14.5344C10.9937 14.6782 10.8155 14.75 10.603 14.75H4.60303Z" fill="currentColor" />
    </svg>
  );
}

export default ReceivedIcon;
